import Popup from "./Popup";
import PopupManager from "./PopupManager";

export { Popup, PopupManager };
export default { Popup, PopupManager };
